import config from '../../../config';
import { Routes } from './types';

const routes: Routes = {
  main: `${config.routerBase}/`,
  login: `${config.routerBase}/login`,
  result: `${config.routerBase}/result`,
  resultDetails: `${config.routerBase}/resultDetails`,
  resultPreview: `${config.routerBase}/resultPreview`,
};

export default routes;
